import { render, staticRenderFns } from "./VerrificationDetailsSumsubApplicantInfo.vue?vue&type=template&id=bcc1a414&"
import script from "./VerrificationDetailsSumsubApplicantInfo.vue?vue&type=script&lang=js&"
export * from "./VerrificationDetailsSumsubApplicantInfo.vue?vue&type=script&lang=js&"
import style0 from "./VerrificationDetailsSumsubApplicantInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports